import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useModalData } from '../../../components/modals/ModalsContext'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('serviceOrders')
  const { ids } = useModalData() || {}
  const key = ids.length > 1 ? 'export.title_plural' : 'export.title'

  return (
    <>
      <Title size="h5" bold>
        {t(key)}
      </Title>
      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
